export const GET_ACADEMIC_STORY = 'GET_ACADEMIC_STORY';
export const LOADING_ACADEMIC_STORY = 'LOADING_ACADEMIC_STORY';
export const SAVE_LOADER_ACADEMIC_STORY = 'SAVE_LOADER_ACADEMIC_STORY';
